<ng-template #template>
  <div class="p-lg-0" [ngClass]="'col-lg-' + width">
    <div class="card hgs">
      <div class="row card-body">
        <div class="col-5">
          <h2>{{ data?.title }}</h2>
          <span class="h2-eq">{{ data?.teamRankText }}</span>
        </div>
        <div class="col-6 my-auto text-center cup">
          <img src="{{ logoImage }}" />
        </div>
      </div>
      <div class="card-footer" [ngClass]="cssColorInv">
        <small
          >{{ data?.takeNextDecisionText }} •
          {{ formatDate(data?.nextDecision) }}</small
        >
      </div>
    </div>
  </div>
</ng-template>
